<template>
    <div>
        <!-- <b-table class="mt-3" hover :items="items"></b-table> -->
        <div class="row">
            <!-- <button class="btn btn-success" v-on:click="exportExcel()"></button> -->
            <div class="form-group float-left row col-xs-12 col-sm-3">
                <label for="staticEmail" class="col-sm-3 col-xs-12 col-form-label">Search :</label>
                <div class="col-sm-9 col-xs-12">
                    <input type="text" placeholder="Input Text Here" class="form-control" v-model="searchText"></input>
                </div>
            </div>
            <download-excel
            class   = "btn btn-success col-xs-12 offset-sm-6 col-sm-3 p-5"
            style="height:50%; background-color: #3A9E4E; border-color: #3A9E4E; border-radius: 4px;"
            :fetch = "exportExcel"
            :fields = "json_fields"
            type = 'xls'
            :name = name>

            <i class="fas fa-file-excel"></i> Export to Excel
            </download-excel>
        </div>
        <div class="table-div">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="headTitle" v-for="header in tableHeaders" @click="selectSort(header.value)">{{ header.name }}</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="item in items" v-on:click="reportDetailPage(item.rq_uuid , item)">
                        <td>{{item.rq_uuid}}</td>
                        <td>{{item.total_vehicle}}</td>
                        <td>{{item.success}}</td>
                        <td>{{item.failed}}</td>
                        <td>{{new Date(item.date - (new Date()).getTimezoneOffset() * 60000).toISOString().replace("T" , " ").slice(0,19)}}</td>
                        <td v-if="item.status == 'Failed'"><div class="statusStyle statusFailed text-center">{{item.status}} </div></td>
                        <td v-else><div class="statusStyle statusSuccess text-center">{{item.status}}</div></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <hr>
        <p v-if="meta">Showing {{1 + ((meta.currentPage - 1) * 10)}} to {{meta.currentPage != meta.lastPage ? meta.currentPage * 10 : meta.total}} of {{meta.total}} entries.</p>
        
        <div class="row">
            <div class="col" style="padding: 20px">
                <nav>
                    <ul class="pagination" style="justify-content:center">
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="laquo()">
                            <span class="page-link">&laquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="lsaquo()">
                            <span class="page-link">&lsaquo;</span>
                        </li>
                        <li class="page-item pageNumber" style="cursor:pointer">
                            <span class="page-link" style="color:black">
                                <span style="font-weight: bold;">{{(config.maxPage < 1) ? 0 : config.currentPage}}</span> of {{config.maxPage}}
                            </span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="rsaquo()">
                            <span class="page-link">&rsaquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="raquo()">
                            <span class="page-link">&raquo;</span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce'

export default {
    data(){
        return {
            items : [],
            options : { year: 'numeric', month: 'long', day: 'numeric' },
            config : {
                currentPage : 1,
                maxPage : 1,
                limitPerPage : 10,//LIMIT PER PAGE
                by : 'date',
                order : true,//true = ascending, false = descending, for start, Reverted
            },
            excelData : null,
            tableHeaders : [],
            tableHeaderTitles : [],
            json_fields: {
                'Rq_uuid': 'rq_uuid',
                'Total Vehicle': 'total_vehicle',
                'No of Success': 'success',
                'No of Failed' : 'failed', 
                'Date' : 'date',
                'Status' : 'status'
            },
            searchText : '',
            name : 'Log Report ' + new Date().toISOString().replace('T').slice(0,10) + '.xls' ,
            meta : null
        }
    },
    created(){
        this.fetchData = debounce(this.fetchData, 1000)
    },
    mounted(){
        this.addTableHeader('rq_uuid', 'RQUUID')
        this.addTableHeader('total_vehicle', 'Total Vehicle')
        this.addTableHeader('success', 'Success Qty')
        this.addTableHeader('failed', 'Failed Qty')
        this.addTableHeader('date', 'Created At')
        this.addTableHeader('status', 'Status')

        this.selectSort('date');//ACT AS FETCH DATA FUNCTION
    },
    computed:{
        orderBy(){
            return {
                by : this.config.by,
                order : (this.config.order) ? 'ASC' : 'DESC'
            }
        },
    },
    watch : {
        '$store.state.updateData' : function(){
            this.fetchData();
        },
        searchText : function(){
            this.fetchData();
        }
    },
    methods : {
        async exportExcel(){
            let url = "/api/log/excel" + this.$store.state.filterUrl;

            if(this.searchText != '')
                url = url + "rq_uuid=" + this.searchText;

            return await this.$http.get(url)
            .then((resp)=>{
                if(resp.data.code != 200)
                    throw new Error(resp.data.message)
                var data = resp.data.data;
                var tzoffset = (new Date()).getTimezoneOffset() * 60000;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].date = new Date(new Date(data[i].date) - tzoffset).toISOString().slice(0, 19).replace('T', ' ')
                }
                return data;
            })
            .catch((err)=>{
                console.log(err);
                
            });
        },
        reportDetailPage(rquuid, data){
            this.$router.push({ name : "LogReportDetails" , params : {rquuid : rquuid , data : data }})
        },
        newError(errorMessage){
            var error = "%c" + errorMessage;
            console.log(error, 'color:#ff0000')
        },
        laquo(){//first page
            if(this.config.currentPage-1 > 0){
                this.fetchData(1, this.orderBy.order, this.orderBy.by);
            } else {
                this.newError("First Page Reached!");
            }
        },
        lsaquo(){//previous page
            if(this.config.currentPage-1 > 0){
                this.fetchData(this.config.currentPage-1, this.orderBy.order, this.orderBy.by);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        rsaquo(){//next page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.currentPage+1, this.orderBy.order, this.orderBy.by);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        raquo(){//last page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.maxPage, this.orderBy.order, this.orderBy.by);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        selectSort(sortVariable){
            if(sortVariable == null){
                alert('Feature Unavailable');
                return;
            }
            if(this.config.by != sortVariable){
                this.config.by = sortVariable
                this.config.order = true
                this.fetchData(1, 'ASC', sortVariable)
            } else {
                this.config.order = !this.config.order
                if(this.config.order)
                    this.fetchData(1, 'ASC', sortVariable)
                else
                    this.fetchData(1, 'DESC', sortVariable)
            }
            this.changeSortTitle();
        },
        changeSortTitle(){
            for(var i = 0; i < this.tableHeaders.length; i++){
                if(this.config.by == this.tableHeaders[i].value){
                    if(this.config.order)
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▲'
                    else
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▼'
                } else {
                    this.tableHeaders[i].name = this.tableHeaderTitles[i]
                }
            }
        },
        addTableHeader(variable, title){
            let header = {
                value : variable,
                name : title
            }
            this.tableHeaders.push(header);
            this.tableHeaderTitles.push(title);
        },
        fetchData(page, order, by){//PAGE(1,2,3,4), ORDER(var-name), BY(asc, desc)

            if(this.$store.state.filterUrl == '')
                return;
                
            var url = `/api/log${this.$store.state.filterUrl}limit=${this.config.limitPerPage}`;

            if(this.searchText != '')
                url = url + "&rq_uuid=" + this.searchText;

            if(by == 'status')//SPECIAL CASE
                by = 'failed'

            if(page)
                url = url + '&page=' + page;
            if(order)
                url = url + '&order=' + order;
            if(by)
                url = url + '&by=' + by;

            this.$http.get(url)
            .then((resp)=>{
         
                var data = resp.data.data;
                var meta = resp.data.meta;

                this.meta = meta;

                this.config.currentPage = meta.currentPage;
                this.config.maxPage = meta.lastPage;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].status = data[i].failed == 0 ? "Success" : "Failed";
                    data[i].date =  new Date(data[i].date);
                }

                this.items = data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
    }
}
</script>

<style scoped>
    tr:hover{
        cursor: pointer;
    }
    .statusFailed{
        background-color: #ff7152;
    }
    .statusSuccess{
        background-color: #68edb6;
    }
    .statusStyle{
        font-weight: bold;
        color : white;
        padding:3px 20px;
        width: 80px;
    }
    .headTitle{
        cursor: pointer;
    }
    .page-link{
        cursor: pointer;
    }
    .pageNumber .page-link:hover{
        background-color: white;
        cursor: default;
    }
    .disabled .page-link{
        background-color:#EEEEEE;
    }
    li .disabled:hover{
        cursor: default;
    }
    .table-div{
        display: block;
        overflow: scroll;
    }
</style>